import {
  jb_headline_with_text_css_default
} from "./chunk.NAJDPU6R.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-headline-with-text/jb-headline-with-text.ts
var JbHeadlineWithText = class extends r {
  render() {
    return ke`
      ${this.headline ? ke`<h4 class="${this.withBorder ? "with-border" : ""}">${this.headline}</h4>` : D}
      ${this.subtitle ? ke`<h5>${this.subtitle}</h5>` : D}
      <slot></slot>
    `;
  }
};
JbHeadlineWithText.styles = jb_headline_with_text_css_default;
__decorateClass([
  n()
], JbHeadlineWithText.prototype, "headline", 2);
__decorateClass([
  n()
], JbHeadlineWithText.prototype, "subtitle", 2);
__decorateClass([
  n({ type: Boolean })
], JbHeadlineWithText.prototype, "withBorder", 2);
JbHeadlineWithText = __decorateClass([
  customElement("jb-headline-with-text")
], JbHeadlineWithText);

export {
  JbHeadlineWithText
};
